(function () {
  'use strict';

  class BannerSlider {
    constructor(sliderEl) {
      this.slider  = sliderEl;
      this.wrap    = sliderEl.closest('.cb-about-banner-image-wrap') || sliderEl.parentElement;
      this.section = sliderEl.closest('.cb-about-banner') || this.wrap;
      this.handle  = this.section.querySelector('[data-slider-handle]');
      if (!this.handle) return;

      this.dragging = false;
      this._onMove  = this._onMove.bind(this);
      this._onEnd   = this._onEnd.bind(this);

      this._set(50);
      this._bind();
    }

    _set(pct) {
      const clamped = Math.max(2, Math.min(98, pct));
      this.wrap.style.setProperty('--split', clamped.toFixed(2) + '%');
      this.section.style.setProperty('--split', clamped.toFixed(2) + '%');
    }

    _pct(clientX) {
      const rect = this.wrap.getBoundingClientRect();
      return ((clientX - rect.left) / rect.width) * 100;
    }

    _bind() {
      // Drag handle
      this.handle.addEventListener('mousedown', (e) => {
        e.preventDefault();
        this.dragging = true;
        this.section.style.cursor = 'ew-resize';
        document.body.style.userSelect = 'none';
        window.addEventListener('mousemove', this._onMove);
        window.addEventListener('mouseup', this._onEnd);
      });

      this.handle.addEventListener('touchstart', () => {
        this.dragging = true;
        window.addEventListener('touchmove', this._onMove, { passive: true });
        window.addEventListener('touchend', this._onEnd);
      }, { passive: true });

      // Click anywhere on the section to jump the handle
      this.section.addEventListener('click', (e) => {
        if (e.target.closest('[data-slider-handle]')) return;
        this._set(this._pct(e.clientX));
      });
    }

    _onMove(e) {
      if (!this.dragging) return;
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      this._set(this._pct(clientX));
    }

    _onEnd() {
      this.dragging = false;
      this.section.style.cursor = '';
      document.body.style.userSelect = '';
      window.removeEventListener('mousemove', this._onMove);
      window.removeEventListener('mouseup', this._onEnd);
      window.removeEventListener('touchmove', this._onMove);
      window.removeEventListener('touchend', this._onEnd);
    }
  }

  function init() {
    document.querySelectorAll('[data-banner-slider]').forEach(el => new BannerSlider(el));
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
